/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class TargetGroupMockDataservice {
  constructor(private http: HttpClient) {}

  getTargetFieldData(): Observable<any> {
    return this.http.get<any>(`${environment.assetsEndPoint}/assets/mock/profile-mgt/target-group-data.json`);
  }

  getDataType(): Observable<any> {
    return this.http.get<any>(`${environment.assetsEndPoint}/assets/mock/profile-mgt/data-type.json`);
  }

  getNewSchemaType(type: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}${environment.wso2amEndPoint}/intelligencemgmt${environment.wso2amApiVersion}/api/v1/dmn/profileIndicators?category=${type}`);
  }
}
